import { useNavigate } from 'react-router-dom';
import HataSayfasi, { HataButon } from './HataSayfasi';
import { IkonPusula } from '../../components/Ikonlar';

export default function Page404() {
  const navigate = useNavigate();

  return (
    <HataSayfasi
      kod="404"
      renk="violet"
      ikon={<IkonPusula size={40} />}
      baslik="Sayfa Bulunamadı"
      aciklama={<>Aradığınız sayfa mevcut değil ya da taşınmış olabilir. Adresi kontrol edip tekrar deneyin.</>}
      altYazi="Kapalı bir modülün sayfasına adres yazarak girilmeye çalışıldığında da bu ekran görünür. Modülleri Ayarlar → Modüller sayfasından açabilirsiniz."
      aksiyonlar={
        <>
          <HataButon onClick={() => navigate(-1)}>← Geri Dön</HataButon>
          <HataButon birincil onClick={() => navigate('/')}>Ana Sayfa</HataButon>
        </>
      }
    />
  );
}
